export var IRetailerLaunchWithFaireApplication;
(function (IRetailerLaunchWithFaireApplication) {
    let State;
    (function (State) {
        State["STATE_UNKNOWN"] = "STATE_UNKNOWN";
        State["SUBMITTED"] = "SUBMITTED";
        State["APPROVED"] = "APPROVED";
        State["REJECTED"] = "REJECTED";
    })(State = IRetailerLaunchWithFaireApplication.State || (IRetailerLaunchWithFaireApplication.State = {}));
    let LeaseSigned;
    (function (LeaseSigned) {
        LeaseSigned["LEASE_SIGNED_UNKNOWN"] = "LEASE_SIGNED_UNKNOWN";
        LeaseSigned["YES"] = "YES";
        LeaseSigned["NO"] = "NO";
        LeaseSigned["OWNED"] = "OWNED";
    })(LeaseSigned = IRetailerLaunchWithFaireApplication.LeaseSigned || (IRetailerLaunchWithFaireApplication.LeaseSigned = {}));
    let LeaseLength;
    (function (LeaseLength) {
        LeaseLength["LEASE_LENGTH_UNKNOWN"] = "LEASE_LENGTH_UNKNOWN";
        LeaseLength["ZERO_SIX_MONTHS"] = "ZERO_SIX_MONTHS";
        LeaseLength["SIX_TWELVE_MONTHS"] = "SIX_TWELVE_MONTHS";
        LeaseLength["ONE_TWO_YEARS"] = "ONE_TWO_YEARS";
        LeaseLength["TWO_FOUR_YEARS"] = "TWO_FOUR_YEARS";
        LeaseLength["OVER_FOUR_YEARS"] = "OVER_FOUR_YEARS";
    })(LeaseLength = IRetailerLaunchWithFaireApplication.LeaseLength || (IRetailerLaunchWithFaireApplication.LeaseLength = {}));
    let FundingAmount;
    (function (FundingAmount) {
        FundingAmount["FUNDING_AMOUNT_UNKNOWN"] = "FUNDING_AMOUNT_UNKNOWN";
        FundingAmount["UNDER_10K"] = "UNDER_10K";
        FundingAmount["RANGE_10K_20K"] = "RANGE_10K_20K";
        FundingAmount["RANGE_20K_50K"] = "RANGE_20K_50K";
        FundingAmount["RANGE_50K_100K"] = "RANGE_50K_100K";
        FundingAmount["RANGE_100K_200K"] = "RANGE_100K_200K";
        FundingAmount["OVER_200K"] = "OVER_200K";
        FundingAmount["NONE"] = "NONE";
    })(FundingAmount = IRetailerLaunchWithFaireApplication.FundingAmount || (IRetailerLaunchWithFaireApplication.FundingAmount = {}));
    let CreditLimit;
    (function (CreditLimit) {
        CreditLimit["CREDIT_LIMIT_UNKNOWN"] = "CREDIT_LIMIT_UNKNOWN";
        CreditLimit["UNDER_5K"] = "UNDER_5K";
        CreditLimit["RANGE_5K_10K"] = "RANGE_5K_10K";
        CreditLimit["RANGE_10K_15K"] = "RANGE_10K_15K";
        CreditLimit["RANGE_15K_25K"] = "RANGE_15K_25K";
        CreditLimit["OVER_25K"] = "OVER_25K";
        CreditLimit["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    })(CreditLimit = IRetailerLaunchWithFaireApplication.CreditLimit || (IRetailerLaunchWithFaireApplication.CreditLimit = {}));
    let PreferredTermsAmount;
    (function (PreferredTermsAmount) {
        PreferredTermsAmount["PREFERRED_TERMS_AMOUNT_UNKNOWN"] = "PREFERRED_TERMS_AMOUNT_UNKNOWN";
        PreferredTermsAmount["TERMS_UNDER_5K"] = "TERMS_UNDER_5K";
        PreferredTermsAmount["TERMS_RANGE_5K_10K"] = "TERMS_RANGE_5K_10K";
        PreferredTermsAmount["TERMS_RANGE_10K_15K"] = "TERMS_RANGE_10K_15K";
        PreferredTermsAmount["TERMS_RANGE_15K_20K"] = "TERMS_RANGE_15K_20K";
        PreferredTermsAmount["TERMS_OVER_20K"] = "TERMS_OVER_20K";
        PreferredTermsAmount["TERMS_RANGE_5K_7K"] = "TERMS_RANGE_5K_7K";
        PreferredTermsAmount["TERMS_UNDER_2500"] = "TERMS_UNDER_2500";
        PreferredTermsAmount["TERMS_RANGE_2500_5K"] = "TERMS_RANGE_2500_5K";
        PreferredTermsAmount["TERMS_RANGE_5K_7500"] = "TERMS_RANGE_5K_7500";
        PreferredTermsAmount["TERMS_RANGE_7500_10K"] = "TERMS_RANGE_7500_10K";
        PreferredTermsAmount["TERMS_OVER_10K"] = "TERMS_OVER_10K";
    })(PreferredTermsAmount = IRetailerLaunchWithFaireApplication.PreferredTermsAmount || (IRetailerLaunchWithFaireApplication.PreferredTermsAmount = {}));
    let MarketingAmount;
    (function (MarketingAmount) {
        MarketingAmount["MARKETING_AMOUNT_UNKNOWN"] = "MARKETING_AMOUNT_UNKNOWN";
        MarketingAmount["MARKETING_UNDER_500"] = "MARKETING_UNDER_500";
        MarketingAmount["MARKETING_RANGE_500_1K"] = "MARKETING_RANGE_500_1K";
        MarketingAmount["MARKETING_RANGE_1K_2K"] = "MARKETING_RANGE_1K_2K";
        MarketingAmount["MARKETING_RANGE_2K_3K"] = "MARKETING_RANGE_2K_3K";
        MarketingAmount["MARKETING_OVER_3K"] = "MARKETING_OVER_3K";
    })(MarketingAmount = IRetailerLaunchWithFaireApplication.MarketingAmount || (IRetailerLaunchWithFaireApplication.MarketingAmount = {}));
    let StoreHoursCommitment;
    (function (StoreHoursCommitment) {
        StoreHoursCommitment["STORE_HOURS_COMMITMENT_UNKNOWN"] = "STORE_HOURS_COMMITMENT_UNKNOWN";
        StoreHoursCommitment["TIME_RANGE_0H_8H"] = "TIME_RANGE_0H_8H";
        StoreHoursCommitment["TIME_RANGE_8H_24H"] = "TIME_RANGE_8H_24H";
        StoreHoursCommitment["TIME_RANGE_24H_40H"] = "TIME_RANGE_24H_40H";
        StoreHoursCommitment["TIME_OVER_40H"] = "TIME_OVER_40H";
    })(StoreHoursCommitment = IRetailerLaunchWithFaireApplication.StoreHoursCommitment || (IRetailerLaunchWithFaireApplication.StoreHoursCommitment = {}));
    let PopUpLease;
    (function (PopUpLease) {
        PopUpLease["POP_UP_LEASE_UNKNOWN"] = "POP_UP_LEASE_UNKNOWN";
        PopUpLease["YES_LEASE"] = "YES_LEASE";
        PopUpLease["NO_LEASE"] = "NO_LEASE";
        PopUpLease["LEASE_NOT_REQUIRED"] = "LEASE_NOT_REQUIRED";
    })(PopUpLease = IRetailerLaunchWithFaireApplication.PopUpLease || (IRetailerLaunchWithFaireApplication.PopUpLease = {}));
    let PopUpMonthsOpen;
    (function (PopUpMonthsOpen) {
        PopUpMonthsOpen["POP_UP_MONTHS_OPEN_UNKNOWN"] = "POP_UP_MONTHS_OPEN_UNKNOWN";
        PopUpMonthsOpen["POPUP_MONTHS_RANGE_0_1"] = "POPUP_MONTHS_RANGE_0_1";
        PopUpMonthsOpen["POPUP_MONTHS_RANGE_1_3"] = "POPUP_MONTHS_RANGE_1_3";
        PopUpMonthsOpen["POPUP_MONTHS_RANGE_3_6"] = "POPUP_MONTHS_RANGE_3_6";
        PopUpMonthsOpen["POPUP_MONTHS_RANGE_6_12"] = "POPUP_MONTHS_RANGE_6_12";
        PopUpMonthsOpen["POPUP_MONTHS_OVER_12"] = "POPUP_MONTHS_OVER_12";
    })(PopUpMonthsOpen = IRetailerLaunchWithFaireApplication.PopUpMonthsOpen || (IRetailerLaunchWithFaireApplication.PopUpMonthsOpen = {}));
    let PopUpHoursOpen;
    (function (PopUpHoursOpen) {
        PopUpHoursOpen["POP_UP_HOURS_OPEN_UNKNOWN"] = "POP_UP_HOURS_OPEN_UNKNOWN";
        PopUpHoursOpen["POPUP_HOURS_UNDER_2"] = "POPUP_HOURS_UNDER_2";
        PopUpHoursOpen["POPUP_HOURS_RANGE_2_4"] = "POPUP_HOURS_RANGE_2_4";
        PopUpHoursOpen["POPUP_HOURS_RANGE_4_8"] = "POPUP_HOURS_RANGE_4_8";
        PopUpHoursOpen["POPUP_HOURS_RANGE_8_12"] = "POPUP_HOURS_RANGE_8_12";
        PopUpHoursOpen["POPUP_HOURS_OVER_12"] = "POPUP_HOURS_OVER_12";
    })(PopUpHoursOpen = IRetailerLaunchWithFaireApplication.PopUpHoursOpen || (IRetailerLaunchWithFaireApplication.PopUpHoursOpen = {}));
    let HasStoreWebsite;
    (function (HasStoreWebsite) {
        HasStoreWebsite["HAS_STORE_WEBSITE_UNKNOWN"] = "HAS_STORE_WEBSITE_UNKNOWN";
        HasStoreWebsite["HAS_WEBSITE"] = "HAS_WEBSITE";
        HasStoreWebsite["NO_WEBSITE"] = "NO_WEBSITE";
        HasStoreWebsite["NOT_STARTED"] = "NOT_STARTED";
        HasStoreWebsite["COMING_SOON"] = "COMING_SOON";
    })(HasStoreWebsite = IRetailerLaunchWithFaireApplication.HasStoreWebsite || (IRetailerLaunchWithFaireApplication.HasStoreWebsite = {}));
    let FicoScore;
    (function (FicoScore) {
        FicoScore["FICO_SCORE_UNKNOWN"] = "FICO_SCORE_UNKNOWN";
        FicoScore["FICO_SCORE_NONE"] = "FICO_SCORE_NONE";
        FicoScore["UNDER_500"] = "UNDER_500";
        FicoScore["BETWEEN_500_TO_600"] = "BETWEEN_500_TO_600";
        FicoScore["BETWEEN_600_TO_650"] = "BETWEEN_600_TO_650";
        FicoScore["BETWEEN_650_TO_700"] = "BETWEEN_650_TO_700";
        FicoScore["BETWEEN_700_TO_750"] = "BETWEEN_700_TO_750";
        FicoScore["OVER_750"] = "OVER_750";
    })(FicoScore = IRetailerLaunchWithFaireApplication.FicoScore || (IRetailerLaunchWithFaireApplication.FicoScore = {}));
    /**
     * @deprecated
     */
    let ApplicationType;
    (function (ApplicationType) {
        /**
         * Use indigofair.data.RetailerLaunchWithFaire.ApplicationType instead.
         */
        ApplicationType["APPLICATION_TYPE_UNKNOWN"] = "APPLICATION_TYPE_UNKNOWN";
        ApplicationType["SOFT_CREDIT_CHECK"] = "SOFT_CREDIT_CHECK";
        ApplicationType["PRE_QUALIFIED"] = "PRE_QUALIFIED";
    })(ApplicationType = IRetailerLaunchWithFaireApplication.ApplicationType || (IRetailerLaunchWithFaireApplication.ApplicationType = {}));
    /**
     * Return an instance of IRetailerLaunchWithFaireApplication with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IRetailerLaunchWithFaireApplication.build = (partial) => (Object.assign({ documents: [], online_website_proof_documents: [], business_tax_documents: [], lease_agreement_documents: [], pop_up_proof_documents: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IRetailerLaunchWithFaireApplication || (IRetailerLaunchWithFaireApplication = {}));
